import { makeStyles } from "@fluentui/react-components";

const useSecuritiesTableStyles = makeStyles({
  root: {
    marginBottom: "12px",
  },
});

export default useSecuritiesTableStyles;
